module.exports = __webpack_public_path__ + "img/ic_nat_home_report.6761b2e3.png";